<template>
  <div class="room-page">
    <!-- 搜索框 -->
    <div class="search-header">
      <van-search
        v-model="searchValue"
        placeholder="搜索群昵称"
        show-action
        @clear="onClear"
      >
        <template #action>
          <div @click="onSearch" style="">搜索</div>
        </template>
      </van-search>
    </div>

    <div class="table-header">
      <div class="checkbox-col">
        <van-checkbox v-model="isAllSelected" @click="handleSelectAll">群组</van-checkbox>
      </div>
      <div class="description-col">群人数</div>
      <div class="time-col">状态</div>
    </div>

    <div class="room-list">
      <div v-if="filteredRooms.length > 0">
        <van-checkbox-group v-model="result" ref="checkboxGroup" @change="onCheckboxGroupChange">
          <div v-for="room in filteredRooms" :key="room.id" class="room-item">
            <div class="checkbox-col">
              <van-checkbox :name="room.room_id">
                <div class="room-info">
                  <img :src="room.room_roomurl || defaultAvatar" alt="群头像" class="room-avatar" />
                  <span class="room-name">{{ room.room_name }}</span>
                </div>
              </van-checkbox>
            </div>
            <div class="description-col">{{ room.room_total }}人</div>
            <div class="time-col">{{ room.status_text }}</div>
          </div>
        </van-checkbox-group>
      </div>
      <div v-else class="empty-state">
        <p>暂无群组数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getUsersChatroomList } from "../../../api/robot.js";
import { Toast } from "vant";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      // 选中的群组ID列表
      result: [],
      // 群组列表数据
      rooms: [],
      // 搜索关键词
      searchValue: '',
      // 默认头像
      defaultAvatar: ''
    };
  },
  created() {
    this.initRoomList();
  },
  computed: {
    // 直接返回rooms数组，搜索通过后端接口实现
    filteredRooms() {
      return this.rooms;
    },
    // 计算是否所有项都被选中
    isAllSelected: {
      get() {
        return this.filteredRooms.length > 0 && this.result.length === this.filteredRooms.length;
      },
      set(val) {
        // 这个setter不会被直接调用，因为我们通过handleSelectAll方法来处理点击事件
      }
    }
  },
  methods: {
    ...mapActions('robot', ['setSelectedRoomIds']),
    
    initRoomList(search='') {
      getUsersChatroomList({room_name: search}).then(res => {
        // res = {
        //   "code": 1,
        //   "msg": "成功",
        //   "time": "1761884090",
        //   "data": [
        //     {
        //       "id": 1,
        //       "room_id": "1",
        //       "room_name": "机器人",
        //       "status": 1,
        //       "room_total": 3,
        //       "room_roomurl": "https:\/\/wework.qpic.cn\/wwpic3az\/451738_MlnobqMySY-4mhE_1761821526\/0",
        //       "room_add_create_time": "2025-10-30 18:51:59",
        //       "status_text": "启用"
        //     }, {
        //       "id": 2,
        //       "room_id": "2",
        //       "room_name": "机器人22",
        //       "status": 1,
        //       "room_total": 3,
        //       "room_roomurl": "https:\/\/wework.qpic.cn\/wwpic3az\/451738_MlnobqMySY-4mhE_1761821526\/0",
        //       "room_add_create_time": "2025-10-30 18:51:59",
        //       "status_text": "启用"
        //     }
        //   ]
        // }
        if (res.code === 1) {
          this.rooms = res.data;
          // 清空之前的选择
          this.result = [];
        } else {
          Toast.fail(res.msg || '获取群组列表失败');
        }
      }).catch(err => {
        Toast.fail('获取群组列表失败');
        console.error('获取群组列表失败:', err);
      });
    },

    // 处理搜索，调用接口并传递room_name参数
    onSearch() {
      this.initRoomList(this.searchValue);
    },

    // 清除搜索
    onClear() {
      this.searchValue = '';
      // 清空搜索后重新获取完整列表
      this.initRoomList();
    },

    // 处理全选
    handleSelectAll() {
      // 确保checkboxGroup已经初始化
      if (this.$refs.checkboxGroup) {
        // 根据当前是否全选来切换状态
        if (this.isAllSelected) {
          // 当前是全选状态，点击后取消全选
          this.result = [];
        } else {
          // 当前不是全选状态，点击后全选
          this.result = this.filteredRooms.map(room => room.room_id);
        }
        // 同步到vuex
        this.setSelectedRoomIds(this.result);
      }
    },

    // CheckboxGroup的change事件处理
    onCheckboxGroupChange() {
      // 勾选群组时直接调用setSelectedRoomIds
      this.setSelectedRoomIds(this.result);
    },
  }
};
</script>

<style scoped lang="less">
.room-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding-bottom: var(--base-px-20);
}

.search-header {
  padding: var(--base-px-12) var(--base-px-16);
  background-color: #f8f8f8;
  border-bottom: var(--base-px-1) solid #f0f0f0;
  
  :deep(.van-search__content) {
    padding-right: var(--base-px-5); /* 为清除按钮和搜索按钮留出足够空间 */
  }
  
  :deep(.van-search__action) {
  }
}

.table-header {
  display: flex;
  padding: var(--base-px-12) var(--base-px-16);
  background-color: #f8f8f8;
  font-size: var(--base-px-14);
  color: #666;
  border-bottom: var(--base-px-1) solid #f0f0f0;

  .checkbox-col {
    flex: 2;
  }

  .description-col {
    flex: 2;
    text-align: center;
  }

  .time-col {
    flex: 1;
    text-align: right;
  }
}

.room-list {
  flex: 1;
  overflow-y: auto;

  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--base-px-20);
    color: #999;
    font-size: var(--base-px-14);
    font-weight: 400;
  }

  .room-item {
    display: flex;
    align-items: center;
    padding: var(--base-px-12) var(--base-px-16);
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .checkbox-col {
      flex: 2;

      .room-info {
        display: flex;
        align-items: center;

        .room-avatar {
          width: var(--base-px-32);
          height: var(--base-px-32);
          border-radius: 8px;
          margin-right: var(--base-px-8);
        }

        .room-name {
          font-size: var(--base-px-14);
          color: #333;
        }
      }
    }

    .description-col {
      flex: 2;
      font-size: var(--base-px-14);
      color: #666;
      text-align: center;
    }

    .time-col {
      flex: 1;
      text-align: right;
      font-size: var(--base-px-14);
      color: #999;
    }
  }
}
</style>